import {Component, Vue} from 'vue-property-decorator'
import {getStudentStaticData} from '@/api/classManage.ts'
import {
    lastMonth,
    lastQuarter,
    lastWeek, lastYear,
    thisMonth,
    thisQuarter,
    thisToday,
    thisWeek, thisYear,
    thisYesterday
} from "@/utils/dateTime";
import * as echarts from 'echarts';

@Component({})
export default class ClassStudentStaticData extends Vue {
    timeType = '1'
    timeStrDate = []
    timeStr = ''
    startWeek = '' // 本周开始
    endWeek = '' //本周结束
    startMonth = '' // 本月开始
    endMonth = ''  //本月结束
    startLastWeek = '' //上周开始
    endLastWeek = '' //上周结束
    startLastMonth = '' // 上月开始
    endLastMonth = ''  // 上月结束
    startQuarter = ''  // 本季度开始
    endQuarter = '' // 本季度结束
    startLastQuarter = '' //上季度开始
    endLastQuarter = '' //上季度结束
    startYear = '' // 本年开始
    endYear = '' // 本年结束
    today = ''
    yesterday = ''
    yesteryearStart = ''
    yesteryearEnd = ''
    loadingGradeBar = false
    loadingGradePie = false
    loadingMajorBar = false
    loadingMajorPie = false
    loadingTypeBar = false
    loadingTypePie = false
    loadingAddressBar = false
    loadingAddressPie = false
    loadingSouBar = false
    loadingSouPie = false

    created() {
        this.getDateInterval()
    }


    //    初始化获取日期区间
    getDateInterval() {
        // 获取今天
        this.today = thisToday();

        // 获取昨天
        this.yesterday = thisYesterday();

        // 本周
        this.startWeek = thisWeek()[0]//周一日期
        this.endWeek = thisWeek()[1];//周日日期

        //上周
        this.startLastWeek = lastWeek()[0]; //周一日期
        this.endLastWeek = lastWeek()[1]; //周日日期

        // 本月
        this.startMonth = thisMonth()[0]
        this.endMonth = thisMonth()[1]

        // 上月
        this.startLastMonth = lastMonth()[0];
        this.endLastMonth = lastMonth()[1];

        // 本季度
        this.startQuarter = thisQuarter()[0];
        this.endQuarter = thisQuarter()[1];

        // 上季度
        this.startLastQuarter = lastQuarter()[0];
        this.endLastQuarter = lastQuarter()[1];

        //本年
        this.startYear = thisYear()[0];
        this.endYear = thisYear()[1];

        // 获取去年
        this.yesteryearStart = lastYear()[0];
        this.yesteryearEnd = lastYear()[1];

        if (this.timeType == '0') {
            this.timeStr = this.yesterday + '&' + this.yesterday
            this.timeStrDate = [this.yesterday, this.yesterday]
            this.getData()
        } else if (this.timeType == '1') {
            this.timeStr = this.today + '&' + this.today
            this.timeStrDate = [this.today, this.today]
            this.getData()
        }

    }

    changeDateType(val) {
        if (val === '2') {  //    本周
            this.timeStr = this.startWeek + '&' + this.endWeek
            this.timeStrDate = [this.startWeek, this.endWeek]
        } else if (val === '3') { // 本月
            this.timeStr = this.startMonth + '&' + this.endMonth
            this.timeStrDate = [this.startMonth, this.endMonth]
        } else if (val === '4') { // 本季度
            this.timeStr = this.startQuarter + '&' + this.endQuarter
            this.timeStrDate = [this.startQuarter, this.endQuarter]
        } else if (val === '5') { // 本年
            this.timeStr = this.startYear + '&' + this.endYear
            this.timeStrDate = [this.startYear, this.endYear]
        } else if (val === '6') { // 上周
            this.timeStr = this.startLastWeek + '&' + this.endLastWeek
            this.timeStrDate = [this.startLastWeek, this.endLastWeek]
        } else if (val === '7') { // 上月
            this.timeStr = this.startLastMonth + '&' + this.endLastMonth
            this.timeStrDate = [this.startLastMonth, this.endLastMonth]
        } else if (val === '8') { // 上季度
            this.timeStr = this.startLastQuarter + '&' + this.endLastQuarter
            this.timeStrDate = [this.startLastQuarter, this.endLastQuarter]
        } else if (val === '9') { // 去年
            this.timeStr = this.yesteryearStart + '&' + this.yesteryearEnd
            this.timeStrDate = [this.yesteryearStart, this.yesteryearEnd]
        } else if (val === '0') { // 昨天
            this.timeStr = this.yesterday + '&' + this.yesterday
            this.timeStrDate = [this.yesterday, this.yesterday]
        } else if (val === '1') { // 今天
            this.timeStr = this.today + '&' + this.today
            this.timeStrDate = [this.today, this.today]
        } else {
            this.timeStr = ''
            this.timeStrDate = []
        }

        if (this.timeStr) {
            this.getData()
        }

    }

    handleChangeData(val) {
        const week = [this.startWeek, this.endWeek]
        const month = [this.startMonth, this.endMonth]
        const year = [this.startYear, this.endYear]
        const quarter = [this.startQuarter, this.endQuarter]
        const lastWeek = [this.startLastWeek, this.endLastWeek]
        const lastMonth = [this.startLastMonth, this.endLastMonth]
        const lastQuarter = [this.startLastQuarter, this.endLastQuarter]
        const lastyear = [this.yesteryearStart, this.yesteryearEnd]
        const yesterday = [this.yesterday, this.yesterday]
        const today = [this.today, this.today]
        if (week[0].indexOf(val[0]) !== -1 && week[1].indexOf(val[1]) !== -1) {
            this.timeType = '2'
        } else if (month[0].indexOf(val[0]) !== -1 && month[1].indexOf(val[1]) !== -1) {
            this.timeType = '3'
        } else if (quarter[0].indexOf(val[0]) !== -1 && quarter[1].indexOf(val[1]) !== -1) {
            this.timeType = '4'
        } else if (year[0].indexOf(val[0]) !== -1 && year[1].indexOf(val[1]) !== -1) {
            this.timeType = '5'
        } else if (lastWeek[0].indexOf(val[0]) !== -1 && lastWeek[1].indexOf(val[1]) !== -1) {
            this.timeType = '6'
        } else if (lastMonth[0].indexOf(val[0]) !== -1 && lastMonth[1].indexOf(val[1]) !== -1) {
            this.timeType = '7'
        } else if (lastQuarter[0].indexOf(val[0]) !== -1 && lastQuarter[1].indexOf(val[1]) !== -1) {
            this.timeType = '8'
        } else if (lastyear[0].indexOf(val[0]) !== -1 && lastyear[1].indexOf(val[1]) !== -1) {
            this.timeType = '9'
        } else if (yesterday[0].indexOf(val[0]) !== -1 && yesterday[1].indexOf(val[1]) !== -1) {
            this.timeType = '0'
        } else if (today[0].indexOf(val[0]) !== -1 && today[1].indexOf(val[1]) !== -1) {
            this.timeType = '1'
        } else {
            this.timeType = '自定义时间'
        }
        this.timeStr = val[0] + '&' + val[1]
        this.getData()
    }

    //  获取统计图
    getData() {
        this.getStudentGradeData() // 年级
        this.getStudentMajorData() // 专业
        this.getStudentTypeData() // 类型
        this.getStudentAdressData() // 升学需求
        this.getStudentSouCourseData() // 报名项目类型
    }

    /*
    * 单独获取年级数据*/
    async getStudentGradeData() {
        this.loadingGradeBar = true
        this.loadingGradePie = true
        const obj = {
            timeStr: this.timeStr,
            groupByType: '0'//年级
        }
        const data: any = await getStudentStaticData(obj)

        const xAxisData = data.studentStatisticalData.map(item => (
            item.group
        ))

        const seriesData = data.studentStatisticalData.map(item => (
            item.count
        ))

        const pieData = data.studentStatisticalData.map(item => ({
                value: item.count,
                name: item.group
            }
        ))

        let sum2 = 0
        pieData.forEach((item, index) => {
            sum2 += Number(item.value)
        })


        /*
       * 学生年级柱状统计图
       * */

        const chartDom: any = document.getElementById('student-grade-bar');
        const myChart = echarts.init(chartDom);
        let option;
        if (xAxisData.length == 0 && seriesData.length == 0) {
            option = {
                title: {
                    text: '暂无数据',
                    x: 'center',
                    y: 'center',
                    textStyle: {
                        fontSize: 14,
                        fontWeight: 'normal',
                    }
                }
            }
        } else {
            option = {
                title: {
                    text: '',
                },
                tooltip: {
                    trigger: 'axis', // 触发类型：坐标轴触发
                    axisPointer: { // 坐标轴指示器配置项
                        type: 'shadow' // 默认为直线，可选为：'line' | 'shadow'
                    }
                },
                xAxis: {
                    type: 'category',
                    data: xAxisData,
                    name: '年级',
                    axisLabel: { //字体展示不全， 斜体展示
                        interval: 0,
                        rotate: -15, //代表逆时针旋转15度
                    }
                },
                yAxis: {
                    type: 'value'
                },
                series: [
                    {
                        data: seriesData,
                        type: 'bar',
                        itemStyle: {
                            normal: {
                                color: '#6495fa'
                            }
                        }
                    }
                ]
            };
        }

        option && myChart.setOption(option)
        this.loadingGradeBar = false

        /*
        * 饼状图*/
        const chartDomPie = document.getElementById('student-grade-pie');
        const myStudentPieChart = echarts.init(chartDomPie);
        let optionStudentPie;
        if (pieData.length == 0) {
            optionStudentPie = {
                title: {
                    text: '暂无数据',
                    x: 'center',
                    y: 'center',
                    textStyle: {
                        fontSize: 14,
                        fontWeight: 'normal',
                    }
                }
            }
        } else {
            optionStudentPie = {
                title: {
                    text: '',
                },
                tooltip: {
                    trigger: 'item'
                },
                // 图例组件
                legend: {
                    type: 'scroll',
                    pageIconColor: '#303313',
                    pageIconInactiveColor: '#909199',
                    pageTextStyle: {
                        color: '#303133',
                        fontSize: 12,
                    },
                    pageIconSize: 12,
                    orient: 'horizontal',// horizontal vertical
                    left: 'center',
                    top: '5%',
                    height: 100,
                    formatter: (name) => {
                        return (name.length > 10 ? (name.slice(0, 10) + "...") : name);
                    },
                },
                series: [
                    {
                        name: '年级',
                        type: 'pie',
                        radius: ['40%', '70%'],
                        avoidLabelOverlap: false,
                        emphasis: {
                            label: {
                                show: true,
                                fontSize: 14,
                                fontWeight: 'bold'
                            }
                        },
                        labelLine: {
                            show: false
                        },
                        data: pieData,
                        label: {
                            show: false,
                            position: 'center',
                            align: 'center',
                            fontSize: 10,
                            formatter: (params) => {
                                let str = params.data.name + '\n'
                                if (params.data.value > 0) {
                                    str += '占比' + (params.data.value / sum2 * 100).toFixed(2) + '%'
                                } else {
                                    str += '0%'
                                }
                                return str
                            }
                        },
                    }
                ]
            };
        }
        optionStudentPie && myStudentPieChart.setOption(optionStudentPie);
        this.loadingGradePie = false
    }

    /*
  * 单独获取学生专业数据*/
    async getStudentMajorData() {
        this.loadingMajorBar = true
        this.loadingMajorPie = true
        const obj = {
            timeStr: this.timeStr,
            groupByType: '1'//专业
        }
        const data: any = await getStudentStaticData(obj)

        const xAxisData = data.studentStatisticalData.map(item => (
            item.group
        ))

        const seriesData = data.studentStatisticalData.map(item => (
            item.count
        ))

        const pieData = data.studentStatisticalData.map(item => ({
                value: item.count,
                name: item.group
            }
        ))
        let sum2 = 0
        pieData.forEach((item, index) => {
            sum2 += Number(item.value)
        })

        /*
       * 学生年级柱状统计图
       * */

        const chartDom = document.getElementById('student-major-bar');
        const myChart = echarts.init(chartDom);
        let option;
        if (xAxisData.length == 0 && seriesData.length == 0) {
            option = {
                title: {
                    text: '暂无数据',
                    x: 'center',
                    y: 'center',
                    textStyle: {
                        fontSize: 14,
                        fontWeight: 'normal',
                    }
                }
            }
        } else {
            option = {
                title: {
                    text: '',
                },
                tooltip: {
                    trigger: 'axis', // 触发类型：坐标轴触发
                    axisPointer: { // 坐标轴指示器配置项
                        type: 'shadow' // 默认为直线，可选为：'line' | 'shadow'
                    }
                },
                xAxis: {
                    type: 'category',
                    data: xAxisData,
                    name: '专业',
                    axisLabel: {
                        show: true, // 显示标签
                        textStyle: {
                            color: 'black' // 文字颜色
                        },
                        //字体展示不全， 斜体展示
                        interval: 0,
                        fontSize: '10px',
                        rotate: -45, //代表逆时针旋转15度
                        formatter: function (params) {
                            let newParamsName = ''// 最终拼接成的字符串
                            const paramsNameNumber = params.length// 实际标签的个数
                            const provideNumber = 6// 每行能显示的字的个数
                            // 判断标签的个数是否大于规定的个数， 如果大于，则进行换行处理 如果不大于，即等于或小于，就返回原标签
                            if (paramsNameNumber > provideNumber) {
                                // ********重点在这里********
                                newParamsName = params.substring(0, 6) + '..'// 最终拼成的字符串
                            } else { // 将旧标签的值赋给新标签
                                newParamsName = params
                            }
                            // 将最终的字符串返回
                            return newParamsName
                        }
                    }
                },
                yAxis: {
                    type: 'value'
                },
                series: [
                    {
                        data: seriesData,
                        type: 'bar',
                        itemStyle: {
                            normal: {
                                color: '#6495fa'
                            }
                        }
                    }
                ]
            };
        }
        option && myChart.setOption(option)
        this.loadingMajorBar = false
        /*
        * 饼状图*/
        const chartDomPie = document.getElementById('student-major-pie');
        const myStudentPieChart = echarts.init(chartDomPie);
        let optionStudentPie;
        if (pieData.length == 0) {
            optionStudentPie = {
                title: {
                    text: '暂无数据',
                    x: 'center',
                    y: 'center',
                    textStyle: {
                        fontSize: 14,
                        fontWeight: 'normal',
                    }
                }
            }
        } else {
            optionStudentPie = {
                title: {
                    text: '',
                },
                tooltip: {
                    trigger: 'item'
                },
                // 图例组件
                legend: {
                    type: 'scroll',
                    pageIconColor: '#303313',
                    pageIconInactiveColor: '#909199',
                    pageTextStyle: {
                        color: '#303133',
                        fontSize: 12,
                    },
                    pageIconSize: 12,
                    orient: 'horizontal',// horizontal vertical
                    left: 'center',
                    top: '5%',
                    height: 100,
                    formatter: (name) => {
                        return (name.length > 10 ? (name.slice(0, 10) + "...") : name);
                    },
                },
                series: [
                    {
                        name: '专业',
                        type: 'pie',
                        radius: ['40%', '70%'],
                        avoidLabelOverlap: false,
                        emphasis: {
                            label: {
                                show: true,
                                fontSize: 14,
                                fontWeight: 'bold'
                            }
                        },
                        labelLine: {
                            show: false
                        },
                        data: pieData,
                        label: {
                            show: false,
                            position: 'center',
                            align: 'center',
                            fontSize: 10,
                            formatter: (params) => {
                                let str = params.data.name + '\n'
                                if (params.data.value > 0) {
                                    str += '占比' + (params.data.value / sum2 * 100).toFixed(2) + '%'
                                } else {
                                    str += '0%'
                                }
                                return str
                            }
                        },
                    }
                ]
            };
        }
        optionStudentPie && myStudentPieChart.setOption(optionStudentPie);
        this.loadingMajorPie = false
    }

    /*
  * 单独获取学生类型数据*/
    async getStudentTypeData() {
        this.loadingTypeBar = true
        this.loadingTypePie = true
        const obj = {
            timeStr: this.timeStr,
            groupByType: '2'//类型
        }
        const data: any = await getStudentStaticData(obj)

        const xAxisData = data.studentStatisticalData.map(item => (
            item.group
        ))

        const seriesData = data.studentStatisticalData.map(item => (
            item.count
        ))

        const pieData = data.studentStatisticalData.map(item => ({
                value: item.count,
                name: item.group
            }
        ))

        let sum2 = 0
        pieData.forEach((item, index) => {
            sum2 += Number(item.value)
        })

        /*
       * 类型柱状统计图
       * */

        const chartDom = document.getElementById('student-type-bar');
        const myChart = echarts.init(chartDom);
        let option;
        if (xAxisData.length == 0 && seriesData.length == 0) {
            option = {
                title: {
                    text: '暂无数据',
                    x: 'center',
                    y: 'center',
                    textStyle: {
                        fontSize: 14,
                        fontWeight: 'normal',
                    }
                }
            }
        } else {
            option = {
                title: {
                    text: '',
                },
                tooltip: {
                    trigger: 'axis', // 触发类型：坐标轴触发
                    axisPointer: { // 坐标轴指示器配置项
                        type: 'shadow' // 默认为直线，可选为：'line' | 'shadow'
                    }
                },
                xAxis: {
                    type: 'category',
                    data: xAxisData,
                    name: '类型',
                    axisLabel: { //字体展示不全， 斜体展示
                        interval: 0,
                        rotate: -15, //代表逆时针旋转15度
                    }
                },
                yAxis: {
                    type: 'value'
                },
                series: [
                    {
                        data: seriesData,
                        type: 'bar',
                        itemStyle: {
                            normal: {
                                color: '#6495fa'
                            }
                        }
                    }
                ]
            };
        }
        option && myChart.setOption(option)
        this.loadingTypeBar = false
        /*
        * 饼状图*/
        const chartDomPie = document.getElementById('student-type-pie');
        const myStudentPieChart = echarts.init(chartDomPie);
        let optionStudentPie;
        if (pieData.length == 0) {
            optionStudentPie = {
                title: {
                    text: '暂无数据',
                    x: 'center',
                    y: 'center',
                    textStyle: {
                        fontSize: 14,
                        fontWeight: 'normal',
                    }
                }
            }
        } else {
            optionStudentPie = {
                title: {
                    text: '',
                },
                tooltip: {
                    trigger: 'item'
                },
                // 图例组件
                legend: {
                    type: 'scroll',
                    pageIconColor: '#303313',
                    pageIconInactiveColor: '#909199',
                    pageTextStyle: {
                        color: '#303133',
                        fontSize: 12,
                    },
                    pageIconSize: 12,
                    orient: 'horizontal',// horizontal vertical
                    left: 'center',
                    top: '5%',
                    height: 100,
                    formatter: (name) => {
                        return (name.length > 10 ? (name.slice(0, 10) + "...") : name);
                    },
                },
                series: [
                    {
                        name: '类型',
                        type: 'pie',
                        radius: ['40%', '70%'],
                        avoidLabelOverlap: false,
                        emphasis: {
                            label: {
                                show: true,
                                fontSize: 14,
                                fontWeight: 'bold'
                            }
                        },
                        labelLine: {
                            show: false
                        },
                        data: pieData,
                        label: {
                            show: false,
                            position: 'center',
                            align: 'center',
                            fontSize: 10,
                            formatter: (params) => {
                                let str = params.data.name + '\n'
                                if (params.data.value > 0) {
                                    str += '占比' + (params.data.value / sum2 * 100).toFixed(2) + '%'
                                } else {
                                    str += '0%'
                                }
                                return str
                            }
                        },
                    }
                ]
            };
        }
        optionStudentPie && myStudentPieChart.setOption(optionStudentPie);
        this.loadingTypePie = false
    }

    /*
  * 单独获取升学需求数据*/
    async getStudentAdressData() {
        this.loadingAddressBar = true
        this.loadingAddressPie = true
        const obj = {
            timeStr: this.timeStr,
            groupByType: '3'//地区
        }
        const data: any = await getStudentStaticData(obj)


        const xAxisData = data.studentStatisticalData.map(item => (
            item.group
        ))

        const seriesData = data.studentStatisticalData.map(item => (
            item.count
        ))

        const pieData = data.studentStatisticalData.map(item => ({
                value: item.count,
                name: item.group
            }
        ))

        let sum2 = 0
        pieData.forEach((item, index) => {
            sum2 += Number(item.value)
        })

        /*
       * 留学地区柱状统计图
       * */

        const chartDom = document.getElementById('student-address-bar');
        const myChart = echarts.init(chartDom);
        let option;
        if (xAxisData.length == 0 && seriesData.length == 0) {
            option = {
                title: {
                    text: '暂无数据',
                    x: 'center',
                    y: 'center',
                    textStyle: {
                        fontSize: 14,
                        fontWeight: 'normal',
                    }
                }
            }
        } else {
            option = {
                title: {
                    text: '',
                },
                tooltip: {
                    trigger: 'axis', // 触发类型：坐标轴触发
                    axisPointer: { // 坐标轴指示器配置项
                        type: 'shadow' // 默认为直线，可选为：'line' | 'shadow'
                    }
                },
                xAxis: {
                    type: 'category',
                    data: xAxisData,
                    name: '升学需求',
                    axisLabel: { //字体展示不全， 斜体展示
                        interval: 0,
                        rotate: -15, //代表逆时针旋转15度
                    }
                },
                yAxis: {
                    type: 'value'
                },
                series: [
                    {
                        data: seriesData,
                        type: 'bar',
                        itemStyle: {
                            normal: {
                                color: '#6495fa'
                            }
                        }
                    }
                ]
            };
        }

        option && myChart.setOption(option)
        this.loadingAddressBar = false
        /*
        * 饼状图*/
        const chartDomPie = document.getElementById('student-address-pie');
        const myStudentPieChart = echarts.init(chartDomPie);
        let optionStudentPie;
        if (pieData.length == 0) {
            optionStudentPie = {
                title: {
                    text: '暂无数据',
                    x: 'center',
                    y: 'center',
                    textStyle: {
                        fontSize: 14,
                        fontWeight: 'normal',
                    }
                }
            }
        } else {
            optionStudentPie = {
                title: {
                    text: '',
                },
                tooltip: {
                    trigger: 'item'
                },
                // 图例组件
                legend: {
                    type: 'scroll',
                    pageIconColor: '#303313',
                    pageIconInactiveColor: '#909199',
                    pageTextStyle: {
                        color: '#303133',
                        fontSize: 12,
                    },
                    pageIconSize: 12,
                    orient: 'horizontal',// horizontal vertical
                    left: 'center',
                    top: '5%',
                    height: 100,
                    formatter: (name) => {
                        return (name.length > 10 ? (name.slice(0, 10) + "...") : name);
                    },
                },
                series: [
                    {
                        name: '升学需求',
                        type: 'pie',
                        radius: ['40%', '70%'],
                        avoidLabelOverlap: false,
                        emphasis: {
                            label: {
                                show: true,
                                fontSize: 14,
                                fontWeight: 'bold'
                            }
                        },
                        labelLine: {
                            show: false
                        },
                        data: pieData,
                        label: {
                            show: false,
                            position: 'center',
                            align: 'center',
                            fontSize: 10,
                            formatter: (params) => {
                                let str = params.data.name + '\n'
                                if (params.data.value > 0) {
                                    str += '占比' + (params.data.value / sum2 * 100).toFixed(2) + '%'
                                } else {
                                    str += '0%'
                                }
                                return str
                            }
                        },
                    }
                ]
            };
        }
        optionStudentPie && myStudentPieChart.setOption(optionStudentPie);
        this.loadingAddressPie = false
    }

    /*
  * 单独报名项目类型数据*/
    async getStudentSouCourseData() {
        this.loadingSouBar = true
        this.loadingSouPie = true
        const obj = {
            timeStr: this.timeStr,
            groupByType: '4'//报名项目类型
        }
        const data: any = await getStudentStaticData(obj)


        const xAxisData = data.studentStatisticalData.map(item => (
            item.group
        ))

        const seriesData = data.studentStatisticalData.map(item => (
            item.count
        ))

        const pieData = data.studentStatisticalData.map(item => ({
                value: item.count,
                name: item.group
            }
        ))

        let sum2 = 0
        pieData.forEach((item, index) => {
            sum2 += Number(item.value)
        })

        /*
       * 报名项目类型柱状统计图
       * */

        const chartDom = document.getElementById('student-souCourse-bar');
        const myChart = echarts.init(chartDom);
        let option;
        if (xAxisData.length == 0 && seriesData.length == 0) {
            option = {
                title: {
                    text: '暂无数据',
                    x: 'center',
                    y: 'center',
                    textStyle: {
                        fontSize: 14,
                        fontWeight: 'normal',
                    }
                }
            }
        } else {
            option = {
                title: {
                    text: '',
                },
                tooltip: {
                    trigger: 'axis', // 触发类型：坐标轴触发
                    axisPointer: { // 坐标轴指示器配置项
                        type: 'shadow' // 默认为直线，可选为：'line' | 'shadow'
                    }
                },
                xAxis: {
                    type: 'category',
                    data: xAxisData,
                    name: '报名项目类型',
                    axisLabel: { //字体展示不全， 斜体展示
                        interval: 0,
                        rotate: -45, //代表逆时针旋转15度
                        formatter: function (params) {
                            // console.log('formatter', params, params.length)
                            let newParamsName = ''// 最终拼接成的字符串
                            const paramsNameNumber = params.length// 实际标签的个数
                            const provideNumber = 6// 每行能显示的字的个数
                            // 判断标签的个数是否大于规定的个数， 如果大于，则进行换行处理 如果不大于，即等于或小于，就返回原标签
                            if (paramsNameNumber > provideNumber) {
                                // ********重点在这里********
                                newParamsName = params.substring(0, 6) + '..'// 最终拼成的字符串
                            } else { // 将旧标签的值赋给新标签
                                newParamsName = params
                            }
                            // 将最终的字符串返回
                            return newParamsName
                        }
                    },
                },


                yAxis: {
                    type: 'value'
                },
                series: [
                    {
                        data: seriesData,
                        type: 'bar',
                        itemStyle: {
                            normal: {
                                color: '#6495fa'
                            }
                        }
                    }
                ]
            };
        }
        option && myChart.setOption(option)
        this.loadingSouBar = false
        /*
        * 饼状图*/
        const chartDomPie = document.getElementById('student-souCourse-pie');
        const myStudentPieChart = echarts.init(chartDomPie);
        let optionStudentPie;
        if (pieData.length == 0) {
            optionStudentPie = {
                title: {
                    text: '暂无数据',
                    x: 'center',
                    y: 'center',
                    textStyle: {
                        fontSize: 14,
                        fontWeight: 'normal',
                    }
                }
            }
        } else {
            optionStudentPie = {
                title: {
                    text: '',
                },
                tooltip: {
                    trigger: 'item'
                },
                // 图例组件
                legend: {
                    type: 'scroll',
                    pageIconColor: '#303313',
                    pageIconInactiveColor: '#909199',
                    pageTextStyle: {
                        color: '#303133',
                        fontSize: 12,
                    },
                    pageIconSize: 12,
                    orient: 'horizontal',// horizontal vertical
                    left: 'center',
                    top: '5%',
                    height: 100,
                    formatter: (name) => {
                        return (name.length > 10 ? (name.slice(0, 10) + "...") : name);
                    },
                },
                series: [
                    {
                        name: '报名项目类型',
                        type: 'pie',
                        radius: ['40%', '70%'],
                        avoidLabelOverlap: false,
                        emphasis: {
                            label: {
                                show: true,
                                fontSize: 14,
                                fontWeight: 'bold'
                            }
                        },
                        labelLine: {
                            show: false
                        },
                        data: pieData,
                        label: {
                            show: false,
                            position: 'center',
                            align: 'center',
                            fontSize: 10,
                            formatter: (params) => {
                                let str = params.data.name + '\n'
                                if (params.data.value > 0) {
                                    str += '占比' + (params.data.value / sum2 * 100).toFixed(2) + '%'
                                } else {
                                    str += '0%'
                                }
                                return str
                            }
                        },
                    }
                ]
            };
        }
        optionStudentPie && myStudentPieChart.setOption(optionStudentPie);
        this.loadingSouPie = false
    }
}